import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import type { CameraPtzAction } from './ptz-controls.types';

export type { CameraPtzAction } from './ptz-controls.types';

@Component({
  selector: 'eventq-ptz-controls',
  imports: [MatIcon],
  templateUrl: './ptz-controls.html',
  styleUrl: './ptz-controls.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqPtzControls {
  readonly disabled = input(false);

  /**
   * Home and presets stay on screen but do nothing until Dealer exposes those
   * routes. Re-enable by setting this to false.
   */
  protected readonly homeAndPresetsDisabled = true;

  readonly command = output<CameraPtzAction>();

  onPointerDown(action: CameraPtzAction, event: Event): void {
    event.preventDefault();
    if (this.disabled()) {
      return;
    }
    this.command.emit(action);
  }

  onPointerUp(event: Event): void {
    event.preventDefault();
    if (this.disabled()) {
      return;
    }
    this.command.emit('stop');
  }

  onClickAction(action: 'home' | 'presets', event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.disabled()) {
      return;
    }
    this.command.emit(action);
  }
}
